import {
  REQUEST_OBD_STATUSES_TRANSLATION_KEY,
  REQUEST_OBD_SUCCESS_READ_TRANSLATION_KEY,
  REQUEST_QUALITY_STATUSES_TRANSLATION_KEY,
  REQUEST_STATUSES_TRANSLATION_KEY,
} from '@core/constants';

export enum RequestStatusesTranslations {
  New = 'request_statuses.1',
  Completed = 'request_statuses.3',
  RequestForEditing = 'request_statuses.6',
  Editing = 'request_statuses.7',
  CheckCompleted = 'request_statuses.8',
  RequestWaitingForCheck = 'request_statuses.9',
  InProgress = 'request_statuses.10',
  Issued = 'request_statuses.11',
  SpecialistAssigned = 'request_statuses.12',
  RequestError = 'request_statuses.13',
  Canceled = 'request_statuses.14',
  Rejected = 'request_statuses.15',
  RejectedLocal = 'request_statuses.16',
}

export type RequestStatusesTranslationsPayload = {
  [key in RequestStatusesTranslations]: string;
};

export enum CoreTranslations {
  NoAccessToOutkeepApp = 'core.no_permission.no_access_to_outkeep_app',
}

export type CoreTranslationsPayload = {
  [key in CoreTranslations]: string;
};

export enum TextCopierTranslations {
  Copied = 'core.text_copier.copied',
  NotFoundToCopy = 'core.text_copier.not_found_to_copy',
}

export type TextCopierTranslationsPayload = {
  [key in TextCopierTranslations]: string;
};

export enum WorkflowsTranslations {
  StartWorkFlowExecution = 'workflows.start_workflow_execution',
  ContinueWorkFlowExecution = 'workflows.continue_workflow_execution',
  PhotoQueueStorageError = 'workflows.photo_queue_storage_error',
  PhotoQueueUploadFailedHint = 'workflows.photo_queue_upload_failed_hint',
  PhotoQueueRemoveFailedHint = 'workflows.photo_queue_remove_failed_hint',
  CancelQueuedUpload = 'workflows.cancel_queued_upload',
  CompleteRequestStep = 'workflows.complete_request_step',
  OfflineFormQueued = 'workflows.offline_form_queued',
  OfflineFormNotSaved = 'workflows.offline_form_not_saved',
  OfflineCompletionQueued = 'workflows.offline_completion_queued',
  OfflineCompletionNotSaved = 'workflows.offline_completion_not_saved',
  DraftNotSavedLocally = 'workflows.draft_not_saved_locally',
  DraftDiscardedVersionChanged = 'workflows.draft_discarded_version_changed',
  LogoutUnsentTitle = 'workflows.logout_unsent_title',
  LogoutUnsentMessage = 'workflows.logout_unsent_message',
  LogoutUnsentConfirm = 'workflows.logout_unsent_confirm',
  LogoutUnsentCancel = 'workflows.logout_unsent_cancel',
  CompleteBlockedPending = 'workflows.complete_blocked_pending',
  DealDetailsNotSaved = 'workflows.deal_details_not_saved',
  PendingStateUnknown = 'workflows.pending_state_unknown',
  FileInvalidType = 'workflows.file_invalid_type',
  FileTooLarge = 'workflows.file_too_large',
  FileTooMany = 'workflows.file_too_many',
  FileUploadFailed = 'workflows.file_upload_failed',
  FileRemoveFailed = 'workflows.file_remove_failed',
  FileNotSavedLocally = 'workflows.file_not_saved_locally',
  FileRejected = 'workflows.file_rejected',
  FilesNotSaved = 'workflows.files_not_saved',
  FilesQueued = 'workflows.files_queued',
}

export type WorkflowsTranslationsPayload = {
  [key in WorkflowsTranslations]: string;
};

export enum WorkflowEventsDialogTranslations {
  ErrorWorkflowNotFound = 'workflows.events_dialog.error_workflow_not_found',
  ErrorLoad = 'workflows.events_dialog.error_load',
  Files = 'workflows.events_dialog.files',
  DefaultWorkflowLabel = 'workflows.events_dialog.default_workflow_label',
  EventIdLabel = 'workflows.events_dialog.event_id_label',
  NoNameWorkflow = 'workflows.events_dialog.no_name_workflow',
  AllHeader = 'workflows.events_dialog.all_header',
  OpenAllButton = 'workflows.events_dialog.open_all_button',
  SystemActorName = 'workflows.events_dialog.system_actor_name',
  DefaultEventLabel = 'workflows.events_dialog.default_event_label',
  DefaultEventStatus = 'workflows.events_dialog.default_event_status',
  WorkflowCreatedLabel = 'workflows.events_dialog.workflow_created_label',
  WorkflowCreatedStatus = 'workflows.events_dialog.workflow_created_status',
  WorkflowInProgressLabel = 'workflows.events_dialog.workflow_in_progress_label',
  WorkflowInProgressStatus = 'workflows.events_dialog.workflow_in_progress_status',
  WorkflowSubmittedLabel = 'workflows.events_dialog.workflow_submitted_label',
  WorkflowSubmittedStatus = 'workflows.events_dialog.workflow_submitted_status',
  SubmissionInvalidLabel = 'workflows.events_dialog.submission_invalid_label',
  SubmissionInvalidStatus = 'workflows.events_dialog.submission_invalid_status',
  SubmissionSyncedLabel = 'workflows.events_dialog.submission_synced_label',
  SubmissionNoChangesStatus = 'workflows.events_dialog.submission_no_changes_status',
  SubmissionValidStatus = 'workflows.events_dialog.submission_valid_status',
  FileUploadedLabel = 'workflows.events_dialog.file_uploaded_label',
  FileUploadedStatus = 'workflows.events_dialog.file_uploaded_status',
  FileDeletedLabel = 'workflows.events_dialog.file_deleted_label',
  FileDeletedStatus = 'workflows.events_dialog.file_deleted_status',
  FileUploadGroupLabel = 'workflows.events_dialog.file_upload_group_label',
}

export type WorkflowEventsDialogTranslationsPayload = {
  [key in WorkflowEventsDialogTranslations]: string;
};

export enum XAlertServiceTranslations {
  Yes = 'core.services.x_alert_service.dialog_yes',
  No = 'core.services.x_alert_service.dialog_no',
}

export type XAlertServiceTranslationsPayload = {
  [key in XAlertServiceTranslations]: string;
};

export enum PositionDefinerTranslations {
  HelpTextSuccess = 'position_definer.help_text_success',
  HelpTextError = 'position_definer.help_text_error',
}

export type PositionDefinerTranslationsPayload = {
  [key in PositionDefinerTranslations]: string;
};

export enum ColumnFiltersTranslations {
  Calendar = 'columns_filters.calendar',
  NotAssigned = 'columns_filters.not_assigned',
  Yes = 'columns_filters.yes',
  No = 'columns_filters.no',
  Group = 'columns_filters.group',
}

export type ColumnFiltersTranslationsPayload = {
  [ColumnFiltersTranslations.Calendar]: {
    yesterday_today_range: string;
    week: string;
    month: string;
    year: string;
  };
  [ColumnFiltersTranslations.NotAssigned]: string;
  [ColumnFiltersTranslations.Yes]: string;
  [ColumnFiltersTranslations.No]: string;
  [ColumnFiltersTranslations.Group]: string;
};

export enum WarehouseServiceTranslations {
  SellRecoverErrorNoRights = 'core.services.warehouse_service.sell_recover_error_no_rights',
  SellRecoverErrorNotFound = 'core.services.warehouse_service.sell_recover_error_not_found',
  SellRecoverErrorUndefinedError = 'core.services.warehouse_service.sell_recover_error_undefined_error',
  CheckSoldUndefinedError = 'core.services.warehouse_service.check_sold_undefined_error',
  CheckSoldForbidden = 'core.services.warehouse_service.check_sold_forbidden',
  CheckSoldNotFound = 'core.services.warehouse_service.check_sold_not_found',
  CheckSoldMayBeProblems = 'core.services.warehouse_service.check_sold_may_be_problems',
}

export type WarehouseServiceTranslationsPayload = {
  [key in WarehouseServiceTranslations]: string;
};

export enum RequestAddressesServiceTranslations {
  SetAddressDialogLabel = 'core.services.request_addresses_service.set_address_dialog_label',
  SetAddressDialogConfirm = 'core.services.request_addresses_service.set_address_dialog_confirm',
  SetAddressDialogCancel = 'core.services.request_addresses_service.set_address_dialog_cancel',
  SetAddressErrorMultiAll = 'core.services.request_addresses_service.set_address_error_multi_all',
  SetAddressErrorMultiSome = 'core.services.request_addresses_service.set_address_error_multi_some',
  SetAddressError = 'core.services.request_addresses_service.set_address_error',
  SetAddressErrorWarning = 'core.services.request_addresses_service.set_address_error_warning',
  SetAddressError403 = 'core.services.request_addresses_service.set_address_error_403',
  SetAddressSuccess = 'core.services.request_addresses_service.set_address_success',
  ResetAddressErrorPermission = 'core.services.request_addresses_service.reset_address_error_permission',
  ResetAddressDialogLabel = 'core.services.request_addresses_service.reset_address_dialog_label',
  ResetAddressDialogConfirm = 'core.services.request_addresses_service.reset_address_dialog_confirm',
  ResetAddressDialogCancel = 'core.services.request_addresses_service.reset_address_dialog_cancel',
  ResetAddressError = 'core.services.request_addresses_service.reset_address_error',
  ResetAddressErrorMultiAll = 'core.services.request_addresses_service.reset_address_error_multi_all',
  ResetAddressErrorMultiSome = 'core.services.request_addresses_service.reset_address_error_multi_some',
  ResetAddressSuccess = 'core.services.request_addresses_service.reset_address_success',
}

export type RequestAddressesServiceTranslationsPayload = {
  [key in RequestAddressesServiceTranslations]: string;
};

export enum RequestRatingsServiceTranslations {
  ErrorGettingRatings = 'core.services.request_ratings_service.error_getting_ratings',
}

export type RequestRatingsServiceTranslationsPayload = {
  [key in RequestRatingsServiceTranslations]: string;
};

export enum RequestDealDetailsServiceTranslations {
  IsCurrentUserInstallerInRequestsWithoutDealDetails = 'core.services.request_deal_details_service.is_current_user_installer_in_requests_without_deal_details',
  ErrorNoSelectedDealDetailsLeft = 'core.services.request_deal_details_service.error_no_selected_deal_details_left',
  ErrorNoPermissionsToEditAllDealDetails = 'core.services.request_deal_details_service.error_no_permissions_to_edit_all_deal_details',
  ErrorSavingDealDetails = 'core.services.request_deal_details_service.error_saving_deal_details',
  Error = 'core.services.request_deal_details_service.error',
  ConfirmDialogYes = 'core.services.request_deal_details_service.confirm_dialog_yes',
  ConfirmDialogNo = 'core.services.request_deal_details_service.confirm_dialog_no',
}

export type RequestDealDetailsServiceTranslationsPayload = {
  [key in RequestDealDetailsServiceTranslations]: string;
};

export enum RequestProductsServiceTranslations {
  ErrorCannotCloseProductsNotValidRequiredFieldsOrForciblyClosed = 'core.services.request_products_service.error_cannot_close_products_not_valid_required_fields_or_forcibly_closed',
  Error = 'core.services.request_products_service.error',
  ErrorSomethingWentWrong = 'core.services.request_products_service.error_something_went_wrong',
  SuccessProductsStatusChanged = 'core.services.request_products_service.success_products_status_changed',
  ErrorCancelForciblyCompletion = 'core.services.request_products_service.error_cancel_forcibly_completion',
  ErrorCancelForciblyCompletionRequirementsNotMet = 'core.services.request_products_service.error_cancel_forcibly_completion_requirements_not_met',
  DialogCancelForciblyCompletion = 'core.services.request_products_service.dialog_cancel_forcibly_completion',
  DialogCancelForciblyCompletionYes = 'core.services.request_products_service.dialog_cancel_forcibly_completion_yes',
  DialogCancelForciblyCompletionNo = 'core.services.request_products_service.dialog_cancel_forcibly_completion_no',
  SuccessCancelForciblyCompletion = 'core.services.request_products_service.success_cancel_forcibly_completion',
  DialogCancelCompletion = 'core.services.request_products_service.dialog_cancel_completion',
  DialogCompletion = 'core.services.request_products_service.dialog_completion',
  DialogCancelCompletionYes = 'core.services.request_products_service.dialog_cancel_completion_yes',
  DialogCompletionYes = 'core.services.request_products_service.dialog_completion_yes',
  DialogCompletionNo = 'core.services.request_products_service.dialog_completion_no',
  SuccessStatusChanged = 'core.services.request_products_service.success_status_changed',
}

export type RequestProductsServiceTranslationsPayload = {
  [key in RequestProductsServiceTranslations]: string;
};

export enum RequestStatusesServiceTranslations {
  UnableChangeStatus = 'core.services.request_statuses_service.unable_change_status',
  NoReleaseDatetimeErrorMessage = 'core.services.request_statuses_service.no_release_datetime_error_message',
  ActualDeliveryAddressNotConfirmedErrorMessage = 'core.services.request_statuses_service.actual_delivery_address_not_confirmed_error_message',
  ReleaseTimeInFutureErrorMessage = 'core.services.request_statuses_service.release_time_in_future_error_message',
  ReleaseDateInPastForCheckErrorMessage = 'core.services.request_statuses_service.release_date_in_past_for_check_error_message',
  Today = 'core.services.request_statuses_service.today',
  ProductsAreNotCompletedErrorMessage = 'core.services.request_statuses_service.products_are_not_completed_error_message',
  DeviceInstallQualityFailedErrorMessage = 'core.services.request_statuses_service.device_install_quality_failed_error_message',
  OnlyCreatorCanChangeStatusFromNew = 'core.services.request_statuses_service.only_creator_can_change_status_from_new',
  StatusChangeForbiddenForCustomer = 'core.services.request_statuses_service.status_change_forbidden_for_customer',
  OnlyCurrentSlsCanChangeDealDetails = 'core.services.request_statuses_service.only_current_sls_can_change_deal_details',
  ReasonQueryToEditRequest = 'core.services.request_statuses_service.reason_query_to_edit_request',
  DialogChangeStatus = 'core.services.request_statuses_service.dialog_change_status',
  DialogChangeStatusYes = 'core.services.request_statuses_service.dialog_change_status_yes',
  DialogChangeStatusNo = 'core.services.request_statuses_service.dialog_change_status_no',
  NoCancellationInitiatorError = 'core.services.request_statuses_service.no_cancellation_initiator_error',
  NoReasonQueryToEditInitiatorError = 'core.services.request_statuses_service.no_reason_query_to_edit_initiator_error',
  DialogNotAllRequestsCanBeChanged = 'core.services.request_statuses_service.dialog_not_all_requests_can_be_changed',
  DialogNotAllRequestsCanBeChangedYes = 'core.services.request_statuses_service.dialog_not_all_requests_can_be_changed_yes',
  DialogNotAllRequestsCanBeChangedNo = 'core.services.request_statuses_service.dialog_not_all_requests_can_be_changed_no',
  AllSelectedRequestsCannotBeChangedError = 'core.services.request_statuses_service.all_selected_requests_cannot_be_changed_error',
  ErrorHappenedTellDevs = 'core.services.request_statuses_service.error_happened_tell_devs',
  ChangeStatuses = 'core.services.request_statuses_service.change_statuses',
  ChangeStatusSuccess = 'core.services.request_statuses_service.change_status_success',
  Warn = 'core.services.request_statuses_service.warn',
  InStatus = 'core.services.request_statuses_service.in_status',
  FromStatus = 'core.services.request_statuses_service.from_status',
  UnableChangeRequest = 'core.services.request_statuses_service.unable_change_request',
  NoDealDetails = 'core.services.request_statuses_service.no_deal_details',
  NoPrimaryDocumentation = 'core.services.request_statuses_service.no_primary_documentation',
}

export type RequestStatusesServiceTranslationsPayload = {
  [key in RequestStatusesServiceTranslations]: string;
};

export enum RequestFormRatingsTranslations {
  ErrorUpdatingRatings = 'request_form.ratings.error_updating_rating',
  SuccessUpdatingRatings = 'request_form.ratings.success_updating_rating',
}

export type RequestFormRatingsTranslationsPayload = {
  [key in RequestFormRatingsTranslations]: string;
};

export enum RequestFormQCRatingsTranslations {
  ErrorUpdatingRating = 'request_form.qc.error_updating_rating',
  SuccessUpdatingRatingQCComment = 'request_form.qc.success_updating_rating_comment',
  ProblemSolved = 'request_form.qc.problem_solved',
  Comment = 'request_form.qc.comment',
  NoComment = 'request_form.qc.no_comment',
}

export type RequestFormQCRatingsTranslationsPayload = {
  [key in RequestFormQCRatingsTranslations]: string;
};

export type RequestOBDStatusesTranslationsPayload = {
  [REQUEST_OBD_STATUSES_TRANSLATION_KEY]: {
    '1': string;
    '2': string;
    '3': string;
    '4': string;
  };
};

export type RequestOBDSuccessReadTranslationsPayload = {
  [REQUEST_OBD_SUCCESS_READ_TRANSLATION_KEY]: {
    '1': string;
    '2': string;
  };
};

export type RequestQualityStatusesTranslationsPayload = {
  [REQUEST_QUALITY_STATUSES_TRANSLATION_KEY]: {
    '0': string;
    '1': string;
    '2': string;
    '3': string;
    '4': string;
    '5': string;
  };
};

export type RequestStatusesIdsTranslationsPayload = {
  [REQUEST_STATUSES_TRANSLATION_KEY]: {
    '1': string;
    '3': string;
    '6': string;
    '7': string;
    '8': string;
    '9': string;
    '10': string;
    '11': string;
    '12': string;
    '13': string;
    '14': string;
    '16': string;
  };
};

export enum RequestFormOBDTranslations {
  DialogUpdateOBDData = 'request_form.obd.dialog_update_obd_data',
  DialogUpdateOBDDataYes = 'request_form.obd.dialog_update_obd_data_yes',
  DialogUpdateOBDDataNo = 'request_form.obd.dialog_update_obd_data_no',
  SuccessUpdatingOBDData = 'request_form.obd.success_updating_OBD_data',
}

export type RequestFormOBDTranslationsPayload = {
  [key in RequestFormOBDTranslations]: string;
};

export enum RequestHistoryLogsTranslations {
  DialogComparingLogsError = 'request_form.request_change_logs.comparing_logs_error',
}

export type RequestHistoryLogsTranslationsPayload = {
  [key in RequestHistoryLogsTranslations]: string;
};

export enum RequestFormInspectionTranslations {
  DialogUpdateInspectionStatus = 'request_form.inspection.dialog_update_inspection_status',
  DialogUpdateInspectionStatusYes = 'request_form.inspection.dialog_update_inspection_status_yes',
  DialogUpdateInspectionStatusNo = 'request_form.inspection.dialog_update_inspection_status_no',
  SuccessUpdatingInspectionStatus = 'request_form.inspection.success_updating_inspection_status',
  ErrorUpdatingInspectionStatus = 'request_form.inspection.error_updating_inspection_status',
  InspectionStatusNotChanged = 'request_form.inspection.inspection_status_not_changed',
}

export type RequestFormInspectionsTranslationsPayload = {
  [key in RequestFormInspectionTranslations]: string;
};

export enum RequestFormGoodsTranslations {
  ErrorsAfterChecking = 'request_form.goods.errors_after_checking',
  SuccessAfterChecking = 'request_form.goods.success_after_checking',
}

export type RequestFormGoodsTranslationsPayload = {
  [key in RequestFormGoodsTranslations]: string;
};

export enum RequestFormFilesTranslations {
  ErrorUploadingFile = 'request_form.files.error_uploading_file',
  SuccessUploadingFile = 'request_form.files.success_uploading_file',
  SuccessUploadingAllFiles = 'request_form.files.success_uploading_all_files',
  ErrorSavingFile = 'request_form.files.error_saving_file',
  DialogDeleteFile = 'request_form.files.dialog_delete_file',
  DialogDeleteFileTitle = 'request_form.files.dialog_delete_file_title',
  DialogDeleteAllCatFilesTitle = 'request_form.files.dialog_delete_all_cat_files',
  SuccessDeletingAllCatFiles = 'request_form.files.success_deleting_all_cat_files',
  ErrorDeletingAllCatFiles = 'request_form.files.error_deleting_all_cat_files',
  SuccessDeletingFile = 'request_form.files.success_deleting_file',
  ErrorDeletingFile = 'request_form.files.error_deleting_file',
  DialogRequestToCancelDeleteTitle = 'request_form.files.dialog_request_to_cancel_delete_title',
  DialogRequestToCancelDeleteMsg = 'request_form.files.dialog_request_to_cancel_delete_msg',
  DialogRequestToDeleteTitle = 'request_form.files.dialog_request_to_delete_title',
  DialogRequestToDeleteMsg1 = 'request_form.files.dialog_request_to_delete_msg_1',
  DialogRequestToDeleteMsg2 = 'request_form.files.dialog_request_to_delete_msg_2',
  SuccessRequestToCancelDelete = 'request_form.files.success_request_to_cancel_delete',
  SuccessRequestToDelete = 'request_form.files.success_request_to_delete',
  ErrorRequestToCancelDelete = 'request_form.files.error_request_to_cancel_delete',
  ErrorRequestToDelete = 'request_form.files.error_request_to_delete',
  VinCopied = 'request_form.files.vin_copied',
  ErrorCopiedVin = 'request_form.files.error_copied_vin',
}

export type RequestFormFilesTranslationsPayload = {
  [key in RequestFormFilesTranslations]: string;
};

export enum RequestFormFilesDownloadTranslations {
  ChecklistNotFound = 'request_form.files.download.checklist_not_found',
  GeneratedFor = 'request_form.files.download.generated_for',
}

export type RequestFormFilesDownloadTranslationsPayload = {
  [key in RequestFormFilesDownloadTranslations]: string;
};

export enum RequestFormFilesSendByEmailTranslations {
  NoFilesSelected = 'request_form.files.download.send_by_email.no_files_selected',
  ErrorSendingFiles = 'request_form.files.download.send_by_email.error_sending_files',
  SuccessSendingFiles = 'request_form.files.download.send_by_email.success_sending_files',
}

export type RequestFormFilesSendByEmailTranslationsPayload = {
  [key in RequestFormFilesSendByEmailTranslations]: string;
};
export enum RequestFormCommentsTranslations {
  DialogDeleteComment = 'request_form.comments.dialog_delete_comment',
  DialogDeleteSelectedComments = 'request_form.comments.dialog_delete_selected_comments',
  DialogDeleteCommentTitle = 'request_form.comments.dialog_delete_comment_title',
  DialogDeleteSelectedCommentsTitle = 'request_form.comments.dialog_delete_selected_comments_title',
  DialogDeleteCommentYes = 'request_form.comments.dialog_delete_comment_yes',
  DialogDeleteCommentNo = 'request_form.comments.dialog_delete_comment_no',
}

export type RequestFormCommentsTranslationsPayload = {
  [key in RequestFormCommentsTranslations]: string;
};

export enum RequestFormCommonSupplierActualDeliveryBlockTranslations {
  DialogChangeReleaseDate = 'request_form.common_supplier.actual_delivery_block.dialog_change_release_date',
  DialogChangeReleaseDateYes = 'request_form.common_supplier.actual_delivery_block.dialog_change_release_date_yes',
  DialogChangeReleaseDateNo = 'request_form.common_supplier.actual_delivery_block.dialog_change_release_date_no',
  SuccessChangeReleaseDate = 'request_form.common_supplier.actual_delivery_block.success_change_release_date',
  DialogResetReleaseDate = 'request_form.common_supplier.actual_delivery_block.dialog_reset_release_date',
  DialogResetReleaseDateYes = 'request_form.common_supplier.actual_delivery_block.dialog_reset_release_date_yes',
  DialogResetReleaseDateNo = 'request_form.common_supplier.actual_delivery_block.dialog_reset_release_date_no',
  SuccessResetReleaseDate = 'request_form.common_supplier.actual_delivery_block.success_reset_release_date',
}

export type RequestFormCommonSupplierActualDeliveryBlockTranslationsPayload = {
  [key in RequestFormCommonSupplierActualDeliveryBlockTranslations]: string;
};

export enum RequestFormDevicesAddDeviceTranslations {
  DialogAddDevice = 'request_form.devices.add_device.dialog_add_device',
  DialogAddDeviceYes = 'request_form.devices.add_device.dialog_add_device_yes',
  DialogAddDeviceNo = 'request_form.devices.add_device.dialog_add_device_no',
  DialogConfirmReleaseDate = 'request_form.devices.add_device.dialog_confirm_release_date',
  DialogConfirmReleaseDateYes = 'request_form.devices.add_device.dialog_confirm_release_date_yes',
  DialogConfirmReleaseDateNo = 'request_form.devices.add_device.dialog_confirm_release_date_no',
  ErrorGettingDeviceModelId = 'request_form.devices.add_device.error_getting_device_model_id',
}

export type RequestFormDevicesAddDeviceTranslationsPayload = {
  [key in RequestFormDevicesAddDeviceTranslations]: string;
};

export enum RequestFormDevicesDeviceRemoverTranslations {
  DialogRemoveDevice = 'request_form.devices.device.remover.dialog_remove_device',
  DialogRemoveDeviceYes = 'request_form.devices.device.remover.dialog_remove_device_yes',
  DialogRemoveDeviceNo = 'request_form.devices.device.remover.dialog_remove_device_no',
}

export type RequestFormDevicesDeviceRemoverTranslationsPayload = {
  [key in RequestFormDevicesDeviceRemoverTranslations]: string;
};

export enum RequestsListItemTranslations {
  EptsNotFound = 'requests_list_item.epts_not_found',
  DocNotFound = 'requests_list_item.doc_not_found',
  GuestLinkCopied = 'requests_list_item.guest_link_copied',
  GuestLinkFailed = 'requests_list_item.guest_link_failed',
  RevokeGuestLinks = 'requests_list_item.revoke_guest_links',
  RevokeGuestLinksConfirmTitle = 'requests_list_item.revoke_guest_links_confirm_title',
  RevokeGuestLinksConfirmText = 'requests_list_item.revoke_guest_links_confirm_text',
  RevokeGuestLinksSuccess = 'requests_list_item.revoke_guest_links_success',
  RevokeGuestLinksFailed = 'requests_list_item.revoke_guest_links_failed',
}

export type RequestsListItemTranslationsPayload = {
  [key in RequestsListItemTranslations]: string;
};

export enum CompleteForciblyModalTranslations {
  FailedToCloseForcibly = 'request_form.complete_forcingly_modal.failed_to_close_forcibly',
}

export type CompleteForciblyModalTranslationsPayload = {
  [key in CompleteForciblyModalTranslations]: string;
};

export enum ReleaseCityTranslations {
  Success = 'request_form.summary.release_city_success',
  Error = 'request_form.summary.release_city_error',
}

export type ReleaseCityTranslationsPayload = {
  [key in ReleaseCityTranslations]: string;
};

export enum MistakesFormTranslations {
  SaveSuccess = 'workflows.mistakes_form.save_success',
  SaveError = 'workflows.mistakes_form.save_error',
  ClearSuccess = 'workflows.mistakes_form.clear_success',
  ClearConfirmTitle = 'workflows.mistakes_form.clear_confirm_title',
  ClearConfirmMessage = 'workflows.mistakes_form.clear_confirm_message',
}

export type MistakesFormTranslationsPayload = {
  [key in MistakesFormTranslations]: string;
};

export type CommonTranslationsPayload = TextCopierTranslationsPayload &
  XAlertServiceTranslationsPayload &
  PositionDefinerTranslationsPayload &
  ColumnFiltersTranslationsPayload &
  WarehouseServiceTranslationsPayload &
  RequestAddressesServiceTranslationsPayload &
  RequestRatingsServiceTranslationsPayload &
  RequestDealDetailsServiceTranslationsPayload &
  RequestProductsServiceTranslationsPayload &
  RequestStatusesServiceTranslationsPayload &
  RequestStatusesTranslationsPayload &
  RequestFormRatingsTranslationsPayload &
  RequestOBDStatusesTranslationsPayload &
  RequestOBDSuccessReadTranslationsPayload &
  RequestFormOBDTranslationsPayload &
  RequestFormInspectionsTranslationsPayload &
  RequestFormGoodsTranslationsPayload &
  RequestFormFilesTranslationsPayload &
  RequestFormFilesDownloadTranslationsPayload &
  RequestFormFilesSendByEmailTranslationsPayload &
  RequestFormCommentsTranslationsPayload &
  RequestFormCommonSupplierActualDeliveryBlockTranslationsPayload &
  RequestFormDevicesAddDeviceTranslationsPayload &
  RequestQualityStatusesTranslationsPayload &
  RequestStatusesIdsTranslationsPayload &
  RequestFormQCRatingsTranslationsPayload &
  RequestHistoryLogsTranslationsPayload &
  CompleteForciblyModalTranslationsPayload &
  RequestsListItemTranslationsPayload &
  CoreTranslationsPayload &
  WorkflowsTranslationsPayload &
  WorkflowEventsDialogTranslationsPayload &
  RequestFormDevicesDeviceRemoverTranslationsPayload &
  MistakesFormTranslationsPayload &
  ReleaseCityTranslationsPayload;
